/**
 * Sunucudaki ManagerGuardFilter'ın 401/403 yanıtlarını kullanıcıya okunur bir uyarıya çevirir.
 * Yanıt gövdesi: { success: false, code, message }.
 */

export const MANAGER_GUARD_CODES = [
  'MANAGER_MODULE_DISABLED',
  'BRANCH_OUT_OF_SCOPE',
  'MANAGER_ENDPOINT_DENIED',
  'MANAGER_ACTION_DENIED',
  'BRANCH_SCOPE_EMPTY',
  'MANAGER_NOT_VERIFIED',
] as const;

export type ManagerGuardCode = (typeof MANAGER_GUARD_CODES)[number];

const MESSAGES: Record<ManagerGuardCode, string> = {
  MANAGER_MODULE_DISABLED: 'Bu modül için yetkiniz yok. Yetki için firma yöneticinize başvurun.',
  BRANCH_OUT_OF_SCOPE: 'Bu şubenin verilerine erişim yetkiniz yok.',
  MANAGER_ENDPOINT_DENIED: 'Bu işlem şube yöneticisi hesabına kapalıdır.',
  MANAGER_ACTION_DENIED: 'Bu işlem şube yöneticisi hesabına kapalıdır.',
  BRANCH_SCOPE_EMPTY: 'Hesabınıza atanmış bir şube bulunamadı. Firma yöneticinize başvurun.',
  MANAGER_NOT_VERIFIED: 'Şube yöneticisi oturumunuz doğrulanamadı. Lütfen yeniden giriş yapın.',
};

/** Aynı uyarı art arda gelen isteklerde ekranı doldurmasın. */
const REPEAT_WINDOW_MS = 5000;

type Listener = (message: string) => void;

let listener: Listener | null = null;
const lastShownAt = new Map<string, number>();

export function setManagerGuardNoticeListener(next: Listener | null): void {
  listener = next;
}

export function getManagerGuardCode(data: unknown): ManagerGuardCode | null {
  const code = (data as { code?: unknown } | null | undefined)?.code;
  return typeof code === 'string' && (MANAGER_GUARD_CODES as readonly string[]).includes(code)
    ? (code as ManagerGuardCode)
    : null;
}

export function getManagerGuardMessage(code: ManagerGuardCode): string {
  return MESSAGES[code];
}

/** Yanıt bir koruma reddiyse uyarıyı gösterir ve kodu döner; değilse null. */
export function handleManagerGuardResponse(status: number | undefined, data: unknown): ManagerGuardCode | null {
  if (status !== 401 && status !== 403) return null;
  const code = getManagerGuardCode(data);
  if (!code) return null;

  const now = Date.now();
  if (now - (lastShownAt.get(code) ?? 0) >= REPEAT_WINDOW_MS) {
    lastShownAt.set(code, now);
    listener?.(MESSAGES[code]);
  }
  return code;
}
